// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__1-wgl","info":"Banner_info__1Ha0r","error":"Banner_error__1UvnI","fantasy":"Banner_fantasy__u9qw7"};